export default "__VITE_ASSET__CjEajJBJ__"